/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:7d7825d0-0f6d-4744-a343-529a4f8e3165",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_e3UZsMOQP",
    "aws_user_pools_web_client_id": "3agg9qbud45bipf6a5cspm2g3k",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "api88e70652",
            "endpoint": "https://yhjs13pg79.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "apibedb9e0d",
            "endpoint": "https://352klg41wg.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "api4580791c",
            "endpoint": "https://pwg3m68tw5.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "api3bf6ef3f",
            "endpoint": "https://280a83v5u1.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "apiemailmarketing",
            "endpoint": "https://n1nrr1yegg.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://zh2bl5df3jer3mlg6sid2mxkgm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "jalegendsdancecourseb14749c3a3814e0fb861fa4477a64451-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
